
webpack.register(
    'modules/history-experience-about/history-experience-about',
    function() {
        return import('modules/history-experience-about/history-experience-about');
    },
    true
);